// Generated Zod schemas from Frappe doctype
import { z } from "zod";
import * as ENUMS from "@/models/enums";

export const personalInformationSchema = z.object({
  first_name: z.string(),
  middle_name: z.string().optional(),
  last_name: z.string(),
  phone_number: z.string()
    .min(10, "Phone number must be at least 10 digits")
    .max(15, "Phone number must be at most 15 digits")
    .transform(phone => phone.replace(/[^0-9]/g, ''))
    .pipe(
      z.string().refine(
        phone => {
          const phoneRegex = /^[0-9]{10,15}$/;
          return phoneRegex.test(phone);
        },
        "Invalid phone number format"
      )
    ),
  gender: ENUMS.GENDER_ENUM,
  date_of_birth: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)").refine((dateString) => {
    // Check if the person is at least 18 years old
    const birthDate = new Date(dateString);
    const today = new Date();

    // Calculate age by getting the difference in years
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // Adjust age if birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age >= 18;
  }, "You must be at least 18 years old"),
  passport_photo: z.instanceof(FileList).optional()
});
export type PersonalInformation = z.infer<typeof personalInformationSchema>;

export const meansOfIdentificationSchema = z.object({
  id_type: ENUMS.ID_TYPE_ENUM,
  id_number: z.string(),
  id_photo: z.instanceof(FileList).optional(),
  bvn: z.string().optional(),
  bvn_photo: z.instanceof(FileList).optional(),
  signature: z.instanceof(FileList).optional()
});
export type MeansOfIdentification = z.infer<typeof meansOfIdentificationSchema>;

export const residentialInformationSchema = z.object({
  state: z.string(),
  lga: ENUMS.LGAS_ENUM.optional(),
});
export type ResidentialInformation = z.infer<typeof residentialInformationSchema>;

export const clusterInformationSchema = z.object({
  cluster: z.string(),
  cooperative_name: z.string(),
  cooperative_role: ENUMS.COOPERATIVE_ROLE_ENUM,
  current_credit_package: z.string().optional(),
  country: z.string(),
  commodity: ENUMS.COMMODITY_ENUM,
});
export type ClusterInformation = z.infer<typeof clusterInformationSchema>;

